import List from '@mui/material/List';
import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import type { Ambition } from '~/shared/data-contract/ambition';

import { SkillChipWithDrawer } from '../../../../common/skills/SkillChipWithDrawer';
import { StyledListItem } from '../Skills';

type AmbitionListProps = {
    readonly ambitions: readonly Ambition[] | undefined;
};

export const AmbitionList: FunctionComponent<AmbitionListProps> = ({ ambitions }) => {
    if (!is.array(ambitions) || !is.nonEmptyArray(ambitions)) {
        return null;
    }

    return (
        <List
            disablePadding={true}
            sx={{
                '&:not(:last-child)': {
                    borderBottom: '1px solid',
                    borderBottomColor: (theme) => theme?.palette.cardborder.main,
                },
            }}
        >
            {ambitions.map((ambition) => (
                <StyledListItem
                    key={ambition.id}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <SkillChipWithDrawer
                        isSynced={ambition.isSynced}
                        label={ambition.title}
                        skillId={ambition.id}
                        type={ambition.skillType}
                        variant="outlined"
                    />
                </StyledListItem>
            ))}
        </List>
    );
};
